import React, { ReactElement, useEffect, useState } from 'react';
import QuoteStatus from '../QuoteStatus';
import rightArrowBlue from 'src/assets/rightArrowBlue.svg';
import downArrowBlue from 'src/assets/downArrowBlue.svg';
import rupeelogo from 'src/assets/rupee.svg';
import clocklogo from 'src/assets/clock.svg';
import { ReactComponent as Rating } from 'src/assets/rating.svg';

import './styles.scss';
import { ReactComponent as TapeLogo } from 'src/assets/quoteCardPills/tape.svg';
import { ReactComponent as CuttableWidth } from 'src/assets/quoteCardPills/16pxcuttablewidth.svg';
import { ReactComponent as Warp } from 'src/assets/quoteCardPills/warp.svg';
import { ReactComponent as Weft } from 'src/assets/quoteCardPills/weft.svg';
import { ReactComponent as Thread } from 'src/assets/quoteCardPills/thread.svg';
import { ReactComponent as Weave } from 'src/assets/quoteCardPills/weave.svg';
import { ReactComponent as Scale } from 'src/assets/quoteCardPills/scale.svg';
import { ReactComponent as Loom } from 'src/assets/quoteCardPills/loom.svg';
import { ReactComponent as Composition } from 'src/assets/quoteCardPills/composition.svg';
import { ReactComponent as RightArrow } from 'src/assets/LCVSupplierDetailsBottomSheet/chevronRight.svg';
import { ReactComponent as ExpressDelivery } from 'src/assets/HomeScreen/expressIcon.svg';
import { ReactComponent as ThreeDots } from 'src/assets/Kebab.svg';
import { ReactComponent as DownloadPI } from 'src/assets/Download_PI.svg';
import { ReactComponent as DownloadPIBlue } from 'src/assets/Download_PI_Blue.svg';
import { ReactComponent as DownloadPackingList } from 'src/assets/Rolls.svg'
// import { ReactComponent as Sampling } from 'src/assets/SamplingBlue.svg'
import { ReactComponent as GreenDot } from 'src/assets/Status.svg';
import { ReactComponent as DeliveredIcon } from 'src/assets/delivered.svg';
import { ReactComponent as ChevronRightIcon } from 'src/assets/chevron_right_white.svg';
import fastestDelivery  from 'src/assets/Fastest delivery.svg'
import moment from 'moment';
import { calcExpiry, formatNumWithCommas, nounWord } from 'src/utils/generic';
import { QuoteCardPill } from '../QuotCardPill';
import {
  DENIM_BLENDS_LABEL,
  DENIM_COTTON_LABEL,
  IS_SHOWING_COMMENTS_TO_CUSTOMER,
  LOOM_TYPE,
  PROCESSING_PRODUCTIONSUBTYPE,
  TAB_NAME,
  TRUNCATE_LENGTH,
  UNITS_PLURAL,
  UNITS_SINGULAR,
  YARN_TYPE_REVERSE,
  conversion,
} from 'src/constants';
import { BottomSheet } from '../BottomSheet';
import QualityGuaranteeTag from '../QuoteStatus/QualityGuaranteeCard';
import {
  QUOTE_CATEGORY_TYPE,
  QUOTE_SUBMISSION_TYPE,
  QUOTE_SUBMISSION_TYPE_REVERSE,
  getAgentSampleChip,
} from 'src/constants/quoute';
import { round } from 'lodash';
import DataLoader from '../DataLoader';

import { PAYMENT_TYPE } from 'src/pages/ComparisonView/comparedata';
import { BUSINESS_NATURE_MANUFACTURER } from '../FabricForm/config';
import CustomTooltip from '../CustomTooltip';
import LocofastAssuredTag from '../QuoteStatus/LocofastAssuredCard';
import { WEIGHT_UNITS, WEIGHT_VALUES } from '../DenimRequestForm/config';
import {downloadPIDetails, fetchDownloadPIReset } from 'src/redux/actions/downloadPI';
import { ReactComponent as GreenTick } from 'src/assets/validateCheck/greenTick.svg';
import { ReactComponent as CloseIcon } from 'src/assets/cross.svg';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { Box, useToast } from '@chakra-ui/react';
import { downloadPackingList } from 'src/redux/actions/downloadPackingList';
// import { fetchSpecimenOptions } from 'src/redux/actions/specimenActions';

type TagProps = {
  handlePlaceOrder: (
    quoteData?: any
  ) => void;
};

const quoteCategoryMap: { [char: number]: string } = {
  1: 'greige',
  2: 'jobwork',
  3: 'bundled',
  4: 'yarndyed',
  5: 'denim',
};

const SPECIMEN_STATUS = {
  PENDING: 1,
  SHARED: 2,
}

export const ORDER_STATUS = {
  NOT_INITIATED: 0,
  INITIATED: 1,
}

export const SPECIMEN_TYPE = {
  SWATCH: 1,
  SAMPLE: 2,
  BOTH: 3,
}

const QuoteDetailsCard = (props: any): ReactElement => {
  const {
    supplierRating,
    setCurrentFocus: setOuterCurrentFocus,
    quoteDetailsFetchStatus,
    denimQuoteSpecifications,
    quoteCategory,
    quoteCategoryComposition,
    orderData,
    id,
    fabricId,
    isBaleAllocated,
    rating,
    reviews,
    // handleRequestSpecimenBtmSheet,
    setSpecimentData,
    specimenType,
    completeJourneyWithSpecimen,
    specimenState,
    unitId,
    setOpenAddressBtmSheet,
    setChangeAddressAction,
    isMultipleSampleRequested,
    setIsMultipleSampleRequested,
    isOrderInitiated = ORDER_STATUS['NOT_INITIATED'],
    agentSampleStatus,
    isAgentSampleRejected,
    handlePlaceOrder = null
  } = props;
  const { afterWashWeight, beforeWashWeight, maxStretch, minStretch, maxWidth, minWidth ,weightUnitId, cuttableWidth } =
    denimQuoteSpecifications || {};
  const compositionData = JSON.parse(quoteCategoryComposition);
  const { parentCategory } = orderData;
  const isBundledQuote = PROCESSING_PRODUCTIONSUBTYPE.includes(props.productionSubTypeId);
  const onTableConstruction = {
    epi: props.onTableConstruction.epi,
    ppi: props.onTableConstruction.ppi,
  };
  const GSM = parseInt(props.expectedFinalWeight);
  const warpType = YARN_TYPE_REVERSE[props.quoteSpecifications.warpType];
  const weftType = YARN_TYPE_REVERSE[props.quoteSpecifications.weftType];
  const AdvancePercentage = parseInt(props.advancePercentage);
  const availabilityType = props.availabilityType;
  const QuoteDate = moment(props.createdOn).format('LLL');
  const expandState = props.isExpandState;
  const { threadcountX, threadcountY } = {
    threadcountX: props.threadcount.x,
    threadcountY: props.threadcount.y,
  };
  const width = props.width;
  const loomTypeNumber = props.loomType ? props.loomType : null;
  const loomType = loomTypeNumber && LOOM_TYPE[loomTypeNumber];
  const tagStatus = calcExpiry(props.createdOn, props.quoteValidity);
  const productType: { [char: string]: string } = {
    '1': 'Readily available',
    '2': 'Made to order',
  };
  const isQualityGuaranteed = props?.isQualityGuaranteed === 1;
  const isLocofastAssured = props.isLocofastAssured === 1;
  const isComment = props?.quoteComment ? true : false;
  const comments = isComment ? props?.quoteComment : '';
  const { supplierName = '' } = isQualityGuaranteed ? { supplierName: 'Locofast' } : props;
  const [isExpanded, setIsExpanded] = useState<boolean>(expandState);
  const [threeDotsMenuClicked, setThreeDotsMenuClicked] = useState<boolean>(false);
  const { total, queryDetails, isDirectInvoicing, isExpressDelivery } = props || {};
  const { symbol } = queryDetails?.currency || {};
  const { isInternational } = queryDetails || {};
  const [currentFocus, setCurrentFocus] = useState('');
  const requiredSpecification = props.requiredSpecification;
  const internationalTotal = total / conversion(props.shortName);
  const canShowRating = rating && !Number.isNaN(rating) && Number(rating) > 0;
  const canShowReviews = reviews && !Number.isNaN(reviews) && Number(reviews) > 0 ;
  const dispatch = useDispatch();

  const __getQuoteSubmissionType = () => {
    if (isInternational) {
      return QUOTE_SUBMISSION_TYPE.Cnf;
    }
    return QUOTE_SUBMISSION_TYPE.XFactory;
  };

  const transformedJourney = (completeJourneyWithSpecimen || []).map((item: any) => {
    const isRequested = item.status === SPECIMEN_STATUS['PENDING'];
    const isCompleted = item.status === SPECIMEN_STATUS['SHARED'];
    const isSpecimen = item.requestType === SPECIMEN_TYPE.SWATCH || item.requestType === SPECIMEN_TYPE.SAMPLE;
    const formattedDate = moment(item.actionTakenOn).format('MMM DD, YYYY, h:mm A');
    let title = item.action;
    const quantity = Number(item.requestedQuantity);
  
    // Check if same specimenId has been shared
    const isAlreadyShared = completeJourneyWithSpecimen.some(
      (j: any) => j.id === item.id && j.status === SPECIMEN_STATUS['SHARED']
    );
  
    if (isRequested && quantity) {
      let quantityText = '';
      if (quantity < 1) {
        const cmValue = quantity * 100;
        quantityText = `${cmValue} cm`;
      } else {
        const unit = quantity > 1 ? `${UNITS_PLURAL[unitId]}` : UNITS_SINGULAR[unitId];
        quantityText = `${quantity} ${unit}`;
      }
      title = `${item.action} (${quantityText})`;
    }

    return {
      title,
      date: formattedDate,
      completed: isCompleted,
      isSpecimen,
      showChangeAddress: isRequested && !isAlreadyShared, // add this
    };
  });

  const showTooltip = supplierName.length > TRUNCATE_LENGTH;
  const denimStretch = `${minStretch}-${maxStretch}% Stretch`;
  const getDenimCondition = (quoteCategoryCompositionData: any) => {
    if (
      quoteCategoryCompositionData[0].name === DENIM_COTTON_LABEL &&
      !minStretch && !maxStretch
    ) {
      return [{ name: DENIM_COTTON_LABEL }];
    }
    if (quoteCategoryCompositionData[0].name === DENIM_BLENDS_LABEL) {
      return [
        {
          name: denimStretch,
        },
      ];
    }
    if (quoteCategoryCompositionData.length > 1) {
      quoteCategoryCompositionData.push({
        name: `(${denimStretch})`,
      });
      return quoteCategoryCompositionData;
    }
  };
  const denimData = getDenimCondition(compositionData);

  const handleDownloadPi = () => {
    dispatch(
      downloadPIDetails({
        fabricId: fabricId,
        quoteId: id,
      }),
    );
    setThreeDotsMenuClicked(false);
  }

  const handleDownloadPackagingList = () => {
    dispatch(
      downloadPackingList({
        fabricId: fabricId,
        quoteId: id,
      }),
    );
    setThreeDotsMenuClicked(false);
  }

  const specimenData = {
      quoteId: props?.id,
      fabricId,
      unitId,
      specimenId: specimenState?.specimenId,           // pass specimen id
      deliveryAddressId: specimenState?.specimenDeliveryAddress?.addressId,
  };
  // const isSpecimenRequested = specimenState && specimenState.status === SPECIMEN_STATUS['PENDING'] ;
  const { label: agentSampleStatusLabel, className: agentSampleStatusClass } = getAgentSampleChip(
    agentSampleStatus,
    isAgentSampleRejected
  );

  // const handleRequestSample = () => {
  //   setSpecimentData(specimenData);
  //   handleRequestSpecimenBtmSheet();
  //   setThreeDotsMenuClicked(false);
  // };
  
  const handleChangeAddress = () =>{
    setSpecimentData(specimenData);
    setChangeAddressAction(true);
    setOpenAddressBtmSheet(true);
  }

  useEffect(()=>{
  setIsMultipleSampleRequested(isMultipleSampleRequested)
  },[isMultipleSampleRequested])

  const Tag = ({ handlePlaceOrder }: TagProps) => {
    return (
      <div className="tagContainer">
        <DeliveredIcon className="icon" />
        <span className="tag-text" onClick={() => {handlePlaceOrder(props)}}>
          Proceed payment
        </span>
        <ChevronRightIcon className="icon" />
      </div>
    );
  };

  return (
    <>
      {/* box */}
      <div className="cursor-pointer">
        {/* Bottom Sheet */}
        { isOrderInitiated === ORDER_STATUS['INITIATED'] && ( <Tag handlePlaceOrder={handlePlaceOrder}/> ) }
        {currentFocus === 'comments' && (
          <div className="-ml-4">
            <BottomSheet
              isDefaultMinHeight
              sheetTitle={'Comment'}
              sheetData={<div className="font-normal text-sm text-gray1 mx-6">{comments}</div>}
              focusHome={setCurrentFocus}
            />
          </div>
        )}

        <div className="ml-8 flex justify-between">
          <div className="w-full">
            <div className="flex">
              {/* Best price tag */}
              {props.isBestPriceQuote && (
                <QuoteStatus className="mt-3 pr-2" statusType="bestprice" />
              )}

              {/* Quality guarantee card */}
              {(isQualityGuaranteed || isLocofastAssured) && (
                <div
                  className="mt-2.5 cursor-pointer pr-2"
                  onClick={(): void => {
                    setOuterCurrentFocus(
                      isQualityGuaranteed
                        ? isBundledQuote
                          ? TAB_NAME.LOCOFAST_QUALITY_QUARANTEE_JOB_WORK_BOTTOMSHEET
                          : TAB_NAME.LOCOFAST_QUALITY_QUARANTEE_BOTTOMSHEET
                        : TAB_NAME.LOCOFAST_ASSURED_BOTTOMSHEET,
                    );
                  }}>
                  {isQualityGuaranteed ? (
                    <QualityGuaranteeTag showChevron />
                  ) : (
                    <LocofastAssuredTag showChevron />
                  )}
                </div>
              )}
            </div>
            <div className=" flex justify-between">
              <div className="flex items-center">
                <QuoteStatus
                  className="mt-3 mr-2"
                  statusType={quoteCategoryMap[props?.quoteCategory]}
                />
                {agentSampleStatusLabel ? (
                  <div className="sampleTextContainer rowLayout inlineChip mt-3 mr-2">
                    <div className="spanTextDiv">
                      <span className={`spanText ${agentSampleStatusClass}`}>{agentSampleStatusLabel}</span>
                    </div>
                  </div>
                ) : null}
                {/* Expired tag */}
                {tagStatus === 'expired' ? (
                  <QuoteStatus className="mt-3 pr-2" statusType="expired" />
                ) : (
                  tagStatus && (
                    <QuoteStatus
                      className="mt-3 pr-2"
                      statusType="expiry"
                      statusValue={String(tagStatus)}
                    />
                  )
                )}
              </div>
              <div
                className=" mt-2 mr-2 h-8 z-10"
                onClick={() => {
                  setThreeDotsMenuClicked(true);
                }}>
                <ThreeDots />
                {threeDotsMenuClicked ? (
                  <div
                    className="relative  bottom-4 items-center bg-white  px-4 py-2 rounded-md border-2 border-lightBlue right-1"
                    style={{ minHeight: 12 }}
                    onClick={(e) => e.stopPropagation()}>
                    <div
                      className="flex items-center"
                      onClick={() => {
                        handleDownloadPi();
                      }}>
                      <DownloadPIBlue />
                      <p className=" ml-1 text-sm">Download PI</p>
                    </div>
                    {isBaleAllocated ? (
                      <div
                        className=" mt-2 mb-1 flex items-center"
                        onClick={() => {
                          handleDownloadPackagingList();
                        }}>
                        <DownloadPackingList />
                        <p className=" ml-1 text-sm">Download packing list</p>
                      </div>
                    ) : null}
                    {/* { !isInternational && specimenType ? (
                      <div
                        className={`mt-2 mb-1 flex items-center ${
                          isSpecimenRequested ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
                        }`}
                        onClick={!isSpecimenRequested ? handleRequestSample : undefined}>
                        <Sampling />
                        <p className="ml-1 text-sm">{__getSpecimenLabel(specimenType)}</p>
                      </div>
                    ) : null } */}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* Express delivery tag */}
          {Boolean(isExpressDelivery) && (
            <div className="bg-statusBg rounded-2xl right-6 mt-3 mb-auto flex justify-end mr-2">
              <div className="flex gap-1 my-0.5 px-2">
                <ExpressDelivery />
                <div className="text-xs text-textOrange">Express delivery</div>
              </div>
            </div>
          )}
        </div>

        <div
          // onClick={(): void => {
          //   setIsExpanded(!isExpanded);
          //   setThreeDotsMenuClicked(false);
          // }}
          >
          <div className="flex justify-between"
          onClick={(): void => {
            setIsExpanded(!isExpanded);
            setThreeDotsMenuClicked(false);
          }}>
            {/* Details 1st */}
            <div className="mx-3 mt-3 flex flex-col">
              <div className="flex">
                {expandState ? (
                  <div className="w-4 mt-1.5 cursor-pointer"></div>
                ) : (
                  <div className="w-4 mt-1.5 cursor-pointer">
                    <img src={isExpanded ? downArrowBlue : rightArrowBlue} alt="ExpandArrow" />
                  </div>
                )}

                <div className="ml-1 mr-3 bg-white border rounded-full h-6 text-center flex pr-1 shadow-sm">
                  <div className="flex justify-around px-1">
                    {quoteDetailsFetchStatus ? (
                      <DataLoader />
                    ) : (
                      <>
                        <div className="ml-px">
                          <span className="text-info text-xs">{symbol}</span>
                        </div>
                        <span className="pt-0.5 p-1 text-sm font-semibold">
                          <span className={tagStatus === 'expired' ? 'line-through' : ''}>
                            {formatNumWithCommas(
                              isInternational
                                ? Number(internationalTotal).toFixed(2)
                                : round(total, 2),
                            )}
                          </span>
                        </span>
                        <span className="text-info  pr-1">{`/ ${props.shortName}`}</span>
                      </>
                    )}
                  </div>
                  <div
                    className={`h-4 ${
                      quoteDetailsFetchStatus && 'pl-5'
                    } bg-typeBg rounded-2xl mt-[3px] text-info text-xs font-normal px-1`}>
                    {QUOTE_SUBMISSION_TYPE_REVERSE[__getQuoteSubmissionType()]}
                  </div>
                </div>
              </div>
              <div className=" ml-4 mt-1.5 flex justify-content px-2 ">
                <img
                  className={isBaleAllocated ? 'h-5 w-5' : 'h-5 w-3'}
                  src={isBaleAllocated ? fastestDelivery : clocklogo}
                />
                <span className="pt-px p-1 text-sm font-semibold">
                  {+props.tat < 2 ? 'Next' : props?.tat}
                </span>
                <span className="text-info pr-1">
                  {+props?.tat < 2 ? ' day dispatch' : `${nounWord('day', props?.tat)} to dispatch`}
                </span>
                {isBaleAllocated ? (
                  <div className="flex bg-orange-400 items-center px-2 rounded-lg h-4 mt-1 ">
                    <p className=" text-white font-bold" style={{ fontSize: 10 }}>
                      Fastest
                    </p>
                  </div>
                ) : null}
              </div>

              {/* { specimenState && specimenState?.status === SPECIMEN_STATUS['PENDING'] ? (
                <div className="sampleTextContainer">
                  <div className="spanTextDiv">
                    <span className="spanText orangeText">{specimenState?.specimenType} pending</span>
                  </div>
                </div>
              ) : null}

              { specimenState && specimenState?.status === SPECIMEN_STATUS['SHARED'] ? (
                <div className="sampleTextContainer">
                  <div className="spanTextDiv">
                    <span className="spanText successText">{specimenState?.specimenType} shared</span>
                  </div>
                </div>
              ) : null} */}
            </div>

            {/* Details 2nd */}
            {supplierName ? (
              <CustomTooltip showTooltip={showTooltip} title={supplierName} position="top-end">
                <div className="bg-PrimaryViolet3 rounded-lg max-h-14 mr-2 text-center text-xs font-semibold shadow-sm py-1 px-2 flex-col gap-1">
                  <div className="text-xs font-semibold py-1 text-naturalViolet flex justify-end">
                    <span className="truncate max-w-[110px]">{supplierName}</span>
                  </div>
                  {canShowRating || canShowReviews ? (
                    <div className="flex justify-end text-naturalViolet text-xs font-normal py-[2px] mt-1">
                      <div className="flex items-center gap-1 min-w-max">
                        {canShowRating ? (
                          <>
                            <Rating className="relative top-[-0.5px]" />
                            <span className="font-semibold">{`${rating}`}</span>
                          </>
                        ) : null}
                        {canShowReviews ? <span>{`(${reviews} reviews)`}</span> : null}
                      </div>
                    </div>
                  ) : null}
                </div>
              </CustomTooltip>
            ) : null}
          </div>

          {/* Fabric Type Pills Area */}
          <div className={`mb-3 mt-1.5  ${denimData ? '' : 'w-90'} `}>
            <div className={`mx-7 flex flex-wrap overflow-hidden ${isExpanded ? null : ' h-6'}`}>
              {quoteCategory !== QUOTE_CATEGORY_TYPE.DENIM ? (
                <>
                  {threadcountX && (
                    <QuoteCardPill
                      icon={<Thread />}
                      text={`${threadcountX} X ${threadcountY}`}
                      isDifferent={
                        threadcountX != requiredSpecification?.requiredThreadcount.x ||
                        threadcountY != requiredSpecification?.requiredThreadcount.y
                      }
                    />
                  )}
                  {onTableConstruction.epi && (
                    <QuoteCardPill
                      icon={<Weave />}
                      text={`${onTableConstruction.epi} X ${onTableConstruction.ppi}`}
                      isDifferent={
                        onTableConstruction.epi !=
                          requiredSpecification?.requiredConstruction.epi ||
                        onTableConstruction.ppi != requiredSpecification?.requiredConstruction.ppi
                      }
                    />
                  )}
                  {loomTypeNumber && (
                    <QuoteCardPill
                      icon={<Loom />}
                      text={loomType}
                      isDifferent={loomTypeNumber != requiredSpecification?.requiredLoomType.id}
                    />
                  )}
                  {width && (
                    <QuoteCardPill
                      icon={<TapeLogo />}
                      text={`${Math.round(width)} inch`}
                      isDifferent={
                        Math.round(width) != Math.round(requiredSpecification?.requiredWidth)
                      }
                    />
                  )}
                  {GSM && (
                    <QuoteCardPill
                      icon={<Scale />}
                      text={`${GSM} ${props?.weightUnit}`}
                      isDifferent={GSM != parseInt(requiredSpecification?.requiredWeight)}
                    />
                  )}
                  {warpType && <QuoteCardPill icon={<Warp />} text={warpType} />}
                  {weftType && <QuoteCardPill icon={<Weft />} text={weftType} />}
                </>
              ) : (
                <>
                  {denimData && (
                    <div className="flex ">
                      <div
                        className={`flex py-0 ${
                          denimData.length > 1 ? 'pr-[6px]' : ''
                        } pl-0 items-center  flex-wrap self-end ${
                          denimData.length > 1 ? 'mx-[5px]' : 'ml-[5px]'
                        }`}>
                        <div className="flex flex-wrap">
                          {denimData.map((data: any, index: number) => {
                            return (
                              <>
                                {index === 0 && (
                                  <div
                                    className={`bg-specialValue flex justify-center items-center rounded-l-lg  p-[1px] border-[0.5px] px-[4px]
                              ${
                                denimData.length > 1 ? ' mb-[4px] ' : ' mt-[4px] '
                              } border-r-0 border-profilePage`}>
                                    <Composition />
                                  </div>
                                )}
                                <div
                                  className={`flex  justify-center items-center border-profilePage 
                            ${
                              denimData.length > 1 ? ' mb-[4px] ' : ' mt-[4px] '
                            } px-1  text-[#6E6CB2] font-semibold
                        ${index == 0 ? 'border-l-0 border-[0.5px] pr-1 text-[12px] text-gray1' : ''}
                        ${
                          index >= 1 && index <= denimData.length - 2
                            ? ' border-[0.5px]  text-[12px] text-gray1'
                            : ''
                        }
                        ${
                          index === denimData.length - 1
                            ? ' border-[0.5px] pr-1 rounded-r-lg text-[12px] text-gray1 mr-1'
                            : ''
                        }
                        `}>
                                  {`${data?.name} ${data.percentage ? `${data.percentage}%` : ''}`}
                                </div>
                              </>
                            );
                          })}
                          <div
                            className={`${
                              denimData.length > 1 ? 'mb-1' : 'self-end'
                            }  mr-1 rounded-lg flex border-[0.5px] ${(
                              threadcountX != requiredSpecification?.requiredThreadcount.x || threadcountY != requiredSpecification?.requiredThreadcount.y
                            ) ? 'border-primaryYellow1' : 'border-profilePage'} `}>
                            <div className="bg-specialValue flex justify-center items-center rounded-l-lg w-6  pl-0.5">
                              {<Thread />}
                            </div>
                            <div className="px-2 text-darkPurple font-semibold text-xs py-[1px]">{threadcountX ? `${threadcountX} x ${threadcountY}` : '--'}</div>
                          </div>
                          <div
                            className={`${
                              denimData.length > 1 ? 'mb-1' : 'self-end'
                            }  mr-1 rounded-lg flex border-[0.5px] border-profilePage `}>
                            <div className="bg-specialValue flex justify-center items-center rounded-l-lg w-6  pl-0.5">
                              {<TapeLogo />}
                            </div>
                            <div className="px-2 text-darkPurple font-semibold text-xs py-[1px]">{`${minWidth}-${maxWidth} inch`}</div>
                          </div>
                          <div
                            className={`${
                              denimData.length > 1 ? 'mb-1' : 'self-end'
                            }  mr-1 rounded-lg flex border-[0.5px] ${(
                              Math.round(cuttableWidth) != Math.round(requiredSpecification?.denimRequiredSpecification?.cuttableWidth)
                            ) ? 'border-primaryYellow1' : 'border-profilePage'} `}>
                            <div className="bg-specialValue flex justify-center items-center rounded-l-lg w-6  pl-0.5">
                              {<CuttableWidth />}
                            </div>
                            <div className="px-2 text-darkPurple font-semibold text-xs py-[1px]">{`${cuttableWidth} inch`}</div>
                          </div>
                          <div
                            className={`${
                              denimData.length > 1 ? 'mb-1' : 'self-end mt-1'
                            } rounded-lg flex border-[0.5px] border-profilePage `}>
                            <div className="bg-specialValue flex justify-center items-center rounded-l-lg w-6  pl-0.5">
                              {<Scale />}
                            </div>
                            <div className="px-2 text-darkPurple font-semibold text-xs py-[1px]">{`${
                              beforeWashWeight || '--'
                            } ${WEIGHT_VALUES[weightUnitId]} ${'(BW)'}`}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Expanded view */}
          {isExpanded && (
            <div className="ml-9 mr-5">
              {!isInternational && (
                <>
                  <div className="flex mt-5 mb-3 font-normal text-xs justify-between ">
                    <div>Logistic Cost</div>
                    <div className="px-1 font-semibold">Extra</div>
                  </div>
                  <div className="border-dashed border-t-[1px] border-lightGray"></div>
                </>
              )}

              {availabilityType ? (
                <>
                  <div className="flex mt-2 mb-3 font-normal text-xs justify-between ">
                    <div>Product type </div>
                    <div className="px-1 font-semibold">{productType[availabilityType]}</div>
                  </div>
                </>
              ) : null}
            </div>
          )}

          {/* Quote Submitted Column */}
          {isExpanded && (
            <>
              <div className="tnaContainer">
                {!isInternational ? (
              transformedJourney.map((item: any, index: any) => {
                return (
                  <div key={index} className="tnaItem">
                    <div className="tnaLeft">
                      {index !== transformedJourney.length - 1 ? <span className="line" /> : null}
                      {item.completed ? (
                        <GreenDot className="tnaGreenDot" />
                      ) : (
                        <div className="h-2 w-2 border-[1.5px] rounded border-info m-1 mx-2"></div>
                      )}
                    </div>
              
                    <div className="tnaRight">
                      <div>
                        <div className="tnaTitleText">{item.title}</div>
                        <div className="tnaDateText">{item.date}</div>
                        {(item?.showChangeAddress) ? 
                        <div className='flex items-center' onClick={handleChangeAddress}>
                        <p className='change-address'>Change address  </p>
                        <div className="w-1 mt-1.5 cursor-pointer ml-1">
                         <img src={rightArrowBlue} alt="ExpandArrow" />
                        </div>
                        </div>
                         : null}
                      </div>
                    </div>
                  </div>
                );
              })
                ) : (
                  <div className="tnaItem">
                    <div className="tnaLeft">
                      <div className="h-2 w-2 border-[1.5px] rounded border-info m-1 mx-2"></div>
                    </div>

                    <div className="tnaRight">
                      <div>
                        <div className="tnaTitleText">Quote Submitted</div>
                        <div className="tnaDateText">{QuoteDate}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {Boolean(isDirectInvoicing) && (
                <div className="mt-6 mb-4 mx-5 text-neutralGray2 text-xs font-normal">
                  {`Locofast is a marketplace, ${supplierName} has authorized Locofast to collect
                payment on its behalf.`}
                </div>
              )}
            </>
          )}
          {IS_SHOWING_COMMENTS_TO_CUSTOMER && isExpanded && isComment && (
            <div
              className=" relative mt-4 ml-7 mr-4 rounded-[4px] h-8 bg-blueBg mb-4 flex cursor-pointer"
              onClick={(): void => {
                setCurrentFocus('comments');
              }}>
              <div className="p-2 truncate text-xs font-normal text-neutralGray2 mr-8">
                {comments}
              </div>
              <RightArrow className="absolute m-2 right-0" />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default QuoteDetailsCard;
